import Handsontable from 'handsontable';

//Cell 렌더러
const yellowRenderer = function(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.backgroundColor = 'yellow';
  };
  const greenRenderer = function(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.backgroundColor = 'green';
  };

//context Menu 정의
const contextMenu = {
    items: {
        // 'row_above' : {name: 'Insert row above this one (custome name)'},
        // 'row_below': {},
        // 'separator' : Handsontable.plugins.ContextMenu.SEPARATOR,
        // 'clear_custom': {name: 'Clear all cells (custom)',callback: function() {this.clear();}},
        'hidden_columns_hide': {name: 'hiddenColumn (custome)'},
        // 'hidden_columns_show': {name: 'showColumn (custome)'},
        'hidden_columns_show': {name: 'showColumn (custome)',callback: function(key, selection, clickEvent) {
            
                var sidx = selection[0].start.col + 1;
                var eidx = selection[0].end.col;
                var show  = [];
                for(let i = sidx; i < eidx; i++) show.push(i)
                var plugin = this.getPlugin('hiddenColumns');
                // console.log(this)
                // console.log(plugin)
                plugin.showColumns(show);
                plugin.hideColumn(2);
                this.render();
            }
        }
    }
}
let body = document.body,
html = document.documentElement;
let height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)*0.61;
//Border 스타일 세팅
const customBorders = [{range:{from:{row:0,col:0},to:{row:0,col:100}},top:{width:3,color:'#e3e6f0'},}];
const initialState = {
    settings: {
        data:[],
        colHeaders: true,
        columns: [{data: 'id', editor: false}],
        stretchH: 'all',
        className: 'b-table has-text-centered',
        tableClassName: 'table is-striped is-hoverable',
        columnHeaderHeight : 33,
        rowHeights: 32,
        // customBorders: customBorders,
        multiColumnSorting: true,
        copyPaste: true,
        dragToScroll: true,
        enterBeginsEditing: true,
        headerAction: true,
        manualColumnFreeze: true,
        hiddenColumns:{columns:[2]},
        // width:'100%',
        // height:height,
        // height:'auto',
        // dropdownMenu: true,
        // contextMenu: contextMenu,
        // filters: true,
        // fixedColumnsLeft: 22,
        licenseKey:"non-commercial-and-evaluation",
    },
};


const state ={
    sheetSettings : initialState.settings,
}        
const mutations ={

    }
const getters ={
    sheetSettings(state) {
        return state.sheetSettings;
    },
}

export default{
    state,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/sheet.js